import * as React from 'react';
import type { SVGProps } from 'react';
const SvgHorizontalBarsStacked = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={33}
    height={28}
    fill="none"
    {...props}
  >
    <path
      fill="#427FF8"
      fillRule="evenodd"
      d="M7 4v4.741h9.42V4z"
      clipRule="evenodd"
    />
    <path
      fill="#C8D9FC"
      fillRule="evenodd"
      d="M15.807 4v4.74h9.645c.748 0 1.355-.606 1.355-1.355v-2.03C26.807 4.606 26.2 4 25.452 4z"
      clipRule="evenodd"
    />
    <path
      fill="#427FF8"
      fillRule="evenodd"
      d="M7 11.451v4.741h6.48v-4.74z"
      clipRule="evenodd"
    />
    <path
      fill="#C8D9FC"
      fillRule="evenodd"
      d="M11.807 11.451v4.74h7.645c.748 0 1.355-.606 1.355-1.354v-2.031c0-.748-.607-1.355-1.355-1.355z"
      clipRule="evenodd"
    />
    <path
      fill="#427FF8"
      fillRule="evenodd"
      d="M6.998 18.902v4.742h8.128v-4.742z"
      clipRule="evenodd"
    />
    <path
      fill="#C8D9FC"
      fillRule="evenodd"
      d="M14.807 18.902v4.74h7.645c.748 0 1.355-.606 1.355-1.354v-2.031c0-.748-.607-1.355-1.355-1.355z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgHorizontalBarsStacked;
